import type { CostGroup, MarginProject, MonthFigures, Severity } from '@ft/shared';

/** Farben der Kostengruppen (wie im Report) und Ton der Schwere für .pill */
export const GROUP_COLOR: Record<CostGroup, string> = { personnel: 'var(--acc-1)', subcontracting: 'var(--acc-2)', other: 'var(--faint)' };
export const SEV_TONE: Record<Severity, 'neg' | 'crit' | 'info' | 'pos'> = { critical: 'neg', watch: 'crit', info: 'info', ok: 'pos' };

/** Monatswerte eines Projekts der Marge-Übersicht für die gemeinsame Analyse (shared/analysis.ts) */
export function figuresOf(p: MarginProject): MonthFigures[] {
  return p.months.map((v, i) => {
    const c = p.costMonths?.[i];
    return {
      netSalesCents: v.netSalesCents, hours: v.hoursX100 / 100,
      costs: c ? { personnel: c.personnel, subcontracting: c.subcontracting, other: c.other } : { personnel: 0, subcontracting: 0, other: v.costCents },
      costDetail: c ? c.costDetail : v.costCents === 0,
    };
  });
}

/** Summe je Kostengruppe über die angegebenen Monate (Index 0–11) */
export function groupTotals(months: MonthFigures[], idx: number[]): Record<CostGroup, number> {
  const out = { personnel: 0, subcontracting: 0, other: 0 };
  for (const i of idx) { const m = months[i]; if (m) { out.personnel += m.costs.personnel; out.subcontracting += m.costs.subcontracting; out.other += m.costs.other; } }
  return out;
}
